import * as React from 'react';

import { createStackNavigator } from '@react-navigation/stack';

import AppHeader from '../components/AppHeader';
import DiscoverScreen from '../screens/discover/DiscoverScreen';
import { getScreenOptions } from './getScreenOptions';
import DynamicScreen from '../screens/screen/DynamicScreen';

export type DiscoverParamList = {
  Discover: { tab?: string };
  DynamicScreen: { screenId: number };
};

const DiscoverStack = createStackNavigator<DiscoverParamList>();

export default function DiscoverNavigator() {
  return (
    <DiscoverStack.Navigator
      initialRouteName='Discover'
      screenOptions={({ route }) => ({
        ...getScreenOptions(route),
        header: () => <AppHeader />,
        headerShown: true,
        headerMode: 'float',
        gestureEnabled: false
      })}
    >
      <DiscoverStack.Screen name='Discover' component={DiscoverScreen} />
      <DiscoverStack.Screen name='DynamicScreen' component={DynamicScreen} />
    </DiscoverStack.Navigator>
  );
}
